<div class="flex gap-5">
  <div class="bg-white rounded-lg px-6 py-5 mt-5 flex-1">
    <div class="grid gap-x-16 gap-y-5 w-full xl:w-2/3 lg:grid-cols-2">
      <app-details-item-placeholder />
      <app-details-item-placeholder />
      <app-details-item-placeholder />
      <app-details-item-placeholder />
    </div>

    <div class="separator"></div>

    <div class="grid gap-x-16 gap-y-5 w-full xl:w-2/3 lg:grid-cols-2">
      <app-details-item-placeholder />
      <app-details-item-placeholder />
      <app-details-item-placeholder />
      <app-details-item-placeholder />
      <app-details-item-placeholder />
    </div>
  </div>

  @if (!singleColumn) {
    <div class="w-[27.5rem]">
      <div class="grid gap-5 w-full bg-white rounded-lg px-6 py-5 mt-5">
        <app-details-item-placeholder />
        <app-details-item-placeholder />
        <app-details-item-placeholder />
        <app-details-item-placeholder />
      </div>
    </div>
  }
</div>
